import React from 'react';
import { motion } from 'framer-motion';
import { 
  Newspaper, ExternalLink, Award, TrendingUp, 
  Quote, Star, Calendar, ArrowRight
} from 'lucide-react';
import Header from './Header';
import Footer from './Footer';

const NaMidiaPage = () => {
  const navigateTo = (url) => {
    window.location.href = url;
  };

  // Menções na mídia
  const mencoes = [
    {
      id: 1,
      titulo: 'Gerenciador para MEI ganha espaço na rotina híbrida',
      fonte: 'Oraculum',
      url: 'https://oraculum.app.br/gerenciador-para-mei-ganha-espaco-na-rotina-hibrida/',
      descricao: 'Como ferramentas de gestão estão ajudando MEIs a equilibrar trabalho presencial e remoto.',
      categoria: 'Gestão',
      data: 'Jan 2025',
      cor: 'emerald'
    },
    {
      id: 2,
      titulo: 'Apps de gestão para MEI evoluem com IA e PIX',
      fonte: 'TecnoHub',
      url: 'https://tecnohub.tec.br/apps-de-gestao-para-mei-evoluem-com-ia-e-pix/',
      descricao: 'A evolução tecnológica dos aplicativos de gestão com inteligência artificial e pagamentos instantâneos.',
      categoria: 'Tecnologia',
      data: 'Jan 2025',
      cor: 'blue'
    },
    {
      id: 3,
      titulo: 'Fluxo de caixa do MEI fica claro com gerenciadores',
      fonte: 'AmigoRico',
      url: 'https://amigorico.app.br/fluxo-de-caixa-do-mei-fica-claro-com-gerenciadores/',
      descricao: 'Como plataformas de gestão financeira estão simplificando o controle de caixa para microempreendedores.',
      categoria: 'Finanças',
      data: 'Jan 2025',
      cor: 'amber'
    },
    {
      id: 4,
      titulo: 'Arquitetura de um gerenciador MEI: do app ao data lake',
      fonte: 'BuildBase',
      url: 'https://buildbase.dev.br/arquitetura-de-um-gerenciador-mei-do-app-ao-data-lake/',
      descricao: 'Uma análise técnica da arquitetura por trás dos sistemas de gestão para MEI.',
      categoria: 'Desenvolvimento',
      data: 'Jan 2025',
      cor: 'purple'
    },
    {
      id: 5,
      titulo: 'Compliance para MEI nos apps: limites e obrigações',
      fonte: 'Parceria Jurídica',
      url: 'https://parceriajuridica.com.br/compliance-para-mei-nos-apps-limites-e-obrigacoes/',
      descricao: 'Os aspectos legais e de conformidade que plataformas de gestão MEI precisam seguir.',
      categoria: 'Jurídico',
      data: 'Jan 2025',
      cor: 'red'
    },
    {
      id: 6,
      titulo: 'Dispositivos que turbinam o MEI: POS, leitor e impressão',
      fonte: 'Eletropedia',
      url: 'https://eletropedia.com.br/dispositivos-que-turbinam-o-mei-pos-leitor-e-impressao/',
      descricao: 'Hardware e dispositivos que complementam a gestão digital do microempreendedor.',
      categoria: 'Hardware',
      data: 'Jan 2025',
      cor: 'gray'
    },
    {
      id: 7,
      titulo: 'Do carrinho ao envio: gestão logística para MEI',
      fonte: 'Entrega Feita',
      url: 'https://entregafeita.log.br/do-carrinho-ao-envio-gestao-logistica-para-mei/',
      descricao: 'Como MEIs estão otimizando sua logística de entregas com ferramentas digitais.',
      categoria: 'Logística',
      data: 'Jan 2025',
      cor: 'orange'
    },
    {
      id: 8,
      titulo: 'Home office do MEI: mais seguro e automatizado',
      fonte: 'Casa Protegida',
      url: 'https://casaprotegida.seg.br/home-office-do-mei-mais-seguro-e-automatizado/',
      descricao: 'Segurança e automação para o microempreendedor que trabalha de casa.',
      categoria: 'Segurança',
      data: 'Jan 2025',
      cor: 'indigo'
    },
    {
      id: 9,
      titulo: 'Equilíbrio mental do MEI: foco, pausas e limites',
      fonte: 'Saúde Confiável',
      url: 'https://saudeconfiavel.seg.br/equilibrio-mental-do-mei-foco-pausas-e-limites/',
      descricao: 'A importância da saúde mental e produtividade equilibrada para empreendedores.',
      categoria: 'Saúde',
      data: 'Jan 2025',
      cor: 'pink'
    },
    {
      id: 10,
      titulo: 'Guia de softwares para MEI: do básico ao avançado',
      fonte: 'Softwares',
      url: 'https://softwares.app.br/guia-de-softwares-para-mei-do-basico-ao-avancado/',
      descricao: 'Um guia completo das melhores ferramentas de software para microempreendedores.',
      categoria: 'Software',
      data: 'Jan 2025',
      cor: 'teal'
    },
  ];

  // Cores das categorias
  const categoryColors = {
    emerald: { bg: '#d1fae5', text: '#059669' },
    blue: { bg: '#dbeafe', text: '#2563eb' },
    amber: { bg: '#fef3c7', text: '#d97706' },
    purple: { bg: '#ede9fe', text: '#7c3aed' },
    red: { bg: '#fee2e2', text: '#dc2626' },
    gray: { bg: '#f3f4f6', text: '#4b5563' },
    orange: { bg: '#ffedd5', text: '#ea580c' },
    indigo: { bg: '#e0e7ff', text: '#4f46e5' },
    pink: { bg: '#fce7f3', text: '#db2777' },
    teal: { bg: '#ccfbf1', text: '#0d9488' }
  };

  // Estatísticas
  const stats = [
    { numero: '10+', label: 'Menções na Mídia', icon: Newspaper },
    { numero: '15M+', label: 'MEIs no Brasil', icon: TrendingUp },
    { numero: '4.9', label: 'Avaliação Média', icon: Star },
  ];

  return (
    <div className="min-h-screen font-sans bg-white">
      {/* Schema.org */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "MeuMei na Mídia - Menções e Cobertura de Imprensa",
          "description": "Veja onde o MeuMei foi mencionado na mídia e imprensa especializada.",
          "url": "https://meumei.net/na-midia"
        })
      }} />

      <Header />

      {/* Hero Section */}
      <section 
        className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden"
        style={{
          background: 'linear-gradient(135deg, #6366F1 0%, #4F46E5 50%, #4338CA 100%)',
        }}
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full opacity-20"
            style={{ background: 'radial-gradient(circle, #ffffff 0%, transparent 70%)' }}
          />
        </div>

        <div className="max-w-4xl mx-auto relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center text-white"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2 }}
              className="w-20 h-20 mx-auto mb-6 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center"
            >
              <Newspaper className="w-10 h-10" />
            </motion.div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              MeuMei na <span className="text-yellow-300">Mídia</span>
            </h1>
            
            <p className="text-lg md:text-xl max-w-2xl mx-auto leading-relaxed opacity-90">
              Confira onde o MeuMei foi mencionado em portais, blogs e 
              veículos especializados em tecnologia e empreendedorismo.
            </p>
          </motion.div>
        </div>

        {/* Wave */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 120" fill="none">
            <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H0Z" fill="white"/>
          </svg>
        </div>
      </section>

      {/* Estatísticas */}
      <section className="py-12 px-4 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-3 gap-4 md:gap-8">
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="text-center"
              >
                <div className="w-12 h-12 mx-auto mb-3 bg-indigo-100 rounded-xl flex items-center justify-center">
                  <stat.icon className="w-6 h-6 text-indigo-600" />
                </div>
                <p className="text-2xl md:text-3xl font-bold text-gray-800">{stat.numero}</p>
                <p className="text-sm text-gray-600">{stat.label}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Citação */}
      <section className="py-12 px-4">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-indigo-50 to-purple-50 border border-indigo-100 rounded-3xl p-8 md:p-12 text-center relative"
          >
            <Quote className="w-12 h-12 text-indigo-300 mx-auto mb-6" />
            <p className="text-xl md:text-2xl text-gray-700 font-medium leading-relaxed mb-6">
              "O MeuMei está transformando a forma como microempreendedores 
              gerenciam seus negócios no Brasil, trazendo simplicidade e 
              automação para quem mais precisa."
            </p>
            <p className="text-indigo-600 font-semibold">— Cobertura da Imprensa, 2025</p>
          </motion.div>
        </div>
      </section>

      {/* Lista de Menções */}
      <section className="py-12 md:py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <Award className="w-6 h-6 text-indigo-500" />
            <h2 className="text-2xl font-bold text-gray-800">Menções e Artigos</h2>
          </div>

          <div className="space-y-4">
            {mencoes.map((mencao, index) => {
              const colors = categoryColors[mencao.cor] || categoryColors.gray;
              return (
                <motion.a
                  key={mencao.id}
                  href={mencao.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  className="flex flex-col md:flex-row md:items-center gap-4 p-6 bg-white border border-gray-200 rounded-2xl hover:shadow-lg hover:border-indigo-200 transition-all group"
                  style={{ textDecoration: 'none' }}
                >
                  {/* Número */}
                  <div className="w-12 h-12 bg-indigo-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <span className="text-indigo-600 font-bold">{String(index + 1).padStart(2, '0')}</span>
                  </div>

                  {/* Conteúdo */}
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-2">
                      <span 
                        className="px-3 py-1 rounded-full text-xs font-medium"
                        style={{ backgroundColor: colors.bg, color: colors.text }}
                      >
                        {mencao.categoria}
                      </span>
                      <span className="text-gray-400 text-sm flex items-center gap-1">
                        <Calendar className="w-3 h-3" />
                        {mencao.data}
                      </span>
                    </div>
                    
                    <h3 className="text-lg font-bold text-gray-800 mb-1 group-hover:text-indigo-600 transition-colors">
                      {mencao.titulo}
                    </h3>
                    
                    <p className="text-gray-500 text-sm mb-2">
                      Fonte: <span className="font-medium text-gray-700">{mencao.fonte}</span>
                    </p>
                    
                    <p className="text-gray-600 text-sm hidden md:block">
                      {mencao.descricao}
                    </p>
                  </div>

                  {/* Link externo */}
                  <div className="flex items-center gap-2 text-indigo-500 group-hover:text-indigo-600 flex-shrink-0">
                    <span className="text-sm font-medium hidden md:block">Ler artigo</span>
                    <ExternalLink className="w-5 h-5" />
                  </div>
                </motion.a>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA para Imprensa */}
      <section className="py-12 md:py-20 px-4 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white border border-gray-200 rounded-3xl p-8 md:p-12"
          >
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
                  É da Imprensa?
                </h2>
                <p className="text-gray-600 mb-6">
                  Se você é jornalista, blogger ou criador de conteúdo e quer falar sobre 
                  o MeuMei, entre em contato conosco. Teremos prazer em ajudar com informações, 
                  entrevistas e materiais.
                </p>
                <div className="space-y-3">
                  <p className="text-gray-700">
                    <strong>E-mail:</strong> imprensa@meumei.net
                  </p>
                  <p className="text-gray-700">
                    <strong>WhatsApp:</strong> (11) 93961-4816
                  </p>
                </div>
              </div>
              
              <div className="text-center md:text-right">
                <motion.button
                  onClick={() => navigateTo('/contato')}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="inline-flex items-center gap-2 px-8 py-4 bg-indigo-600 text-white font-bold rounded-xl shadow-lg hover:bg-indigo-700 transition-colors"
                >
                  Falar com a Equipe
                  <ArrowRight className="w-5 h-5" />
                </motion.button>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-12 md:py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-emerald-500 to-teal-600 rounded-3xl p-8 md:p-12 text-center text-white"
          >
            <h2 className="text-2xl md:text-4xl font-bold mb-4">
              Junte-se a milhares de MEIs!
            </h2>
            <p className="text-lg opacity-90 mb-8 max-w-2xl mx-auto">
              Descubra por que o MeuMei está sendo destaque na mídia. 
              Experimente grátis por 7 dias!
            </p>
            <motion.button
              onClick={() => navigateTo('https://app.meumei.net/register')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 bg-white text-emerald-600 font-bold rounded-xl shadow-lg"
            >
              Criar Conta Grátis
            </motion.button>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NaMidiaPage;